import { plural } from '@cian/utils';
import { NBSP } from '../../../constants/symbols';

export const getProjectsCount = (count: number): string | undefined => {
  return count ? count + NBSP + plural(count, ['проект', 'проекта', 'проектов']) : undefined;
};
